import { CurrencyPipe, DatePipe } from "@angular/common";
import { AuctionBidAdminDTO } from "../DTO/auctionBidAdminDTO";
import { Bid } from "./bid";

export class AuctionBidAdmin extends Bid{
    public userId!:string;
    public userName!:string;
    public firstName!:string;
    public lastName!:string;
    public role!:string;
    public bidAmount!:number;
    public proxyBid:boolean = false;
    public equalized:boolean = false;
    public equalizedReason?:EqualizedReason[];
    public representingBrokerId?:number; //is undefined when there is no representation and >0 when there is one.
    public proxyBidHistory?:ProxyBidHistory[];
    public voidReason?:string;
    public voidIndex?:number;

    public historicProxyAction?:string;

    public static mapToDTO(param:AuctionBidAdmin) : AuctionBidAdminDTO{
        
        let dto = new AuctionBidAdminDTO();
        try
        {
            dto.id = param.id;
            dto.auctionId = param.auctionId;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            dto.currentBid = param.currentBid;
            dto.bidDateTime = param.bidDateTime.toISOString();
            dto.autoBid = param.autoBid;
            dto.bidAccepted = param.bidAccepted;
            dto.askAmount = param.askAmount;
            dto.askAmountExclusivitySeconds = param.askAmountExclusivitySeconds;
            dto.askAccepted = param.askAccepted;
            dto.isBackup = param.isBackup;
            dto.userId = param.userId;
            dto.userName = param.userName;
            dto.firstName = param.firstName;
            dto.lastName = param.lastName;
            dto.role = param.role;
            dto.bidAmount = param.bidAmount;
            dto.proxyBid = param.proxyBid;
            dto.equalized = param.equalized;
            dto.equalizedReason = JSON.stringify(param.equalizedReason);
            dto.representingBrokerId = param.representingBrokerId;
            //dto.proxyBidHistory = param.proxyBidHistory; don't worry about this as we never will transmit this to server anyways
            dto.voidReason = param.voidReason;
            dto.voidIndex = param.voidIndex;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:AuctionBidAdminDTO) : AuctionBidAdmin
    {
        
        let obj = new AuctionBidAdmin();
        try
        {
            obj.id = param.id;
            obj.auctionId = param.auctionId;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            obj.currentBid = param.currentBid;
            obj.bidDateTime = new Date(param.bidDateTime);
            obj.autoBid = param.autoBid;
            obj.bidAccepted = param.bidAccepted;
            obj.askAmount = param.askAmount;
            obj.askAmountExclusivitySeconds = param.askAmountExclusivitySeconds;
            obj.askAccepted = param.askAccepted;
            obj.isBackup = param.isBackup;
            obj.userId = param.userId;
            obj.userName = param.userName;
            obj.firstName = param.firstName;
            obj.lastName = param.lastName;
            obj.role = param.role;
            obj.bidAmount = param.bidAmount;
            obj.proxyBid = param.proxyBid;
            obj.equalized = param.equalized;
            obj.equalizedReason =[];
            if(param.equalizedReason){
                let arr = <EqualizedReason[]>JSON.parse(param.equalizedReason);
                arr.forEach(item => obj.equalizedReason!.push(Object.assign(new EqualizedReason(),item)));
            }
            obj.representingBrokerId = param.representingBrokerId;
            if(param.proxyBidHistory) {
                obj.proxyBidHistory = [];
                //remove trailing ; then split
                param.proxyBidHistory.replace(/;+$/, '').split(';').forEach(pbh=>{
                    var pbh_elements = pbh.split('|');
                    obj.proxyBidHistory!.push(new ProxyBidHistory(new Date(pbh_elements[0]), pbh_elements[1], Number(pbh_elements[2])));
                });
                obj.proxyBidHistory.sort((a,b) => b.timeStamp.getTime()-a.timeStamp.getTime());
            }
            obj.voidReason = param.voidReason;
            obj.voidIndex = param.voidIndex;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get proxyAmount(){
        return this.proxyBid?this.bidAmount:undefined;
    }

    get historicProxyAmount(){
        return this.proxyBidHistory?.length?this.proxyBidHistory.find(pbh => pbh.timeStamp.getTime()<=this.bidDateTime.getTime())?.amount:this.proxyAmount;
    }

    get equalizedIndicator(){
        return this.equalized?'*':'';
    }

    get equalizedReasonTooltip(){
       return this.equalizedReason?.map(r=>r.equalizedReasonFormatted).join('\n');
    }
}

export class EqualizedReason{
    public reason!:string;
    public date!:Date;
    public byUser!:string
    public from!:number;
    public to!:number;

    private datePipe = new DatePipe('en-US');
    private currencyPipe = new CurrencyPipe('en-US');

    get equalizedReasonFormatted(){
        return this.datePipe.transform(this.date, 'short')+':'+ this.currencyPipe.transform(this.from, 'USD', 'symbol', '1.0-2') + '->' + this.currencyPipe.transform(this.to, 'USD', 'symbol', '1.0-2') + ' (' + this.reason + ')';
    }
}

export class ProxyBidHistory{
    public timeStamp:Date;
    public action:string;
    public amount:number;

    public constructor(timeStamp:Date, action:string, amount:number){
        this.timeStamp=timeStamp;
        this.action=action;
        this.amount=amount;
    }   
}